import { createAction } from 'redux-starter-kit';
import { asyncGetUserInfo, asyncGetPaymentInfo } from 'actions/user';
import { loginSuccess } from 'actions/auth';
import * as api from 'api/sso-app';

export const fetchSsoAppStatus = createAction('sso-app/FETCH_STATUS');
export const fetchSsoAppStatusSuccess = createAction('sso-app/FETCH_STATUS_SUCCESS');
export const fetchSsoAppStatusFailure = createAction('sso-app/FETCH_STATUS_FAILURE');

export const loginViaSsoApp = createAction('sso-app/LOGIN_VIA_SSO_APP');
export const loginViaSsoAppStatusSuccess = createAction('sso-app/LOGIN_VIA_SSO_APP_SUCCESS');
export const loginViaSsoAppStatusFailure = createAction('sso-app/LOGIN_VIA_SSO_APP_FAILURE');

export const asyncFetchSsoAppStatus = more => async dispatch => {
  dispatch(fetchSsoAppStatus());

  api
    .fetchSsoAppStatus()
    .then(results => {
      dispatch(fetchSsoAppStatusSuccess(results));
    })
    .catch(error => {
      dispatch(fetchSsoAppStatusFailure({ error: error.message }));
    });
};

export const asyncLoginViaSsoApp = more => async dispatch => {
  dispatch(loginViaSsoApp());

  api
    .signInWithUmbrella()
    .then(results => {
      dispatch(loginViaSsoAppStatusSuccess(results));

      if (results.status === 'success') {
        dispatch(
          loginSuccess({
            token: results.token,
            rememberMe: true
          })
        );
        dispatch(asyncGetUserInfo());
        dispatch(asyncGetPaymentInfo());
      } else {
        dispatch(loginViaSsoAppStatusFailure(results.message || 'Unable to login using Voomly Cloud'));
      }
    })
    .catch(error => {
      const errorMessage = error.response?.data?.error | error.message | 'Unable to login using Voomly Cloud';

      dispatch(loginViaSsoAppStatusFailure(errorMessage));
    });
};
